import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { get } from 'lodash'
import { connect } from 'react-redux'
import { FormattedMessage } from 'react-intl'
import { FormattedDate } from 'components/intl'
import { compose } from 'recompose'

import { Modal, Export, DuplicityInfo } from 'containers/misc'
import { TaskApprove, TaskParticipantEdit } from 'containers/forms/tasks'
import { FilterTasksRegistration } from 'containers/filters'
import { Table, Data } from 'components/layout/Table'
import { Button, Status, BadgesLevels, ButtonGroup, RowSelectorTd } from 'components/misc'
import { tasks as tasksLayout } from 'constants/layout'
import {
  apiTasksRegistrationParticipants,
  apiParticipants,
  apiConfiguration,
  apiAwards
} from 'helpers/decorators/api'
import { modal, notification } from 'redux/modules/app'
import { meta, tableCommon } from 'helpers/decorators'
import { CONFIGURATION_KEYS, CONSENT_DELIVERY_TYPES } from 'constants/enums'
import { BulkChangeAwardRegistrations } from 'containers/bulkChange'
import config from 'config'
import { getLabels } from '../../../helpers/labelHelper'


const enhance = compose(
  meta({
    title: 'Tasks - Registration',
    intlKey: 'pageTitle.tasks_registration',
    dynamicProp: 'organizations.detail.name'
  }),
  apiTasksRegistrationParticipants({
    participants: true,
    useCommonLimit: true,
    bulk: true
  }),
  apiConfiguration(),
  apiParticipants({
    updateTasks: true
  }),
  apiAwards({
    updateRegistrationTasks: true
  }),
  tableCommon(),
  connect(({ auth }) => ({
    activeOrganization: auth.organization
  }),
      { modal, notification })
)

class TasksRegistrationParticipants extends Component {
  static propTypes = {
    tasks: PropTypes.object.isRequired,
    modal: PropTypes.func.isRequired,
    onGetTasksParticipantRegistration: PropTypes.func.isRequired,
    onRefreshTaskParticipantRegistration: PropTypes.func.isRequired,
    deleteParticipantRegistration: PropTypes.func.isRequired,
    exportParticipantRegistrations: PropTypes.func.isRequired,
    setRegistrationTasksParams: PropTypes.func,
    approveParticipantRegistration: PropTypes.func.isRequired,
    onRegistrationAwardEdit: PropTypes.func.isRequired,
    disablePersistedFilter: PropTypes.bool,
    withAwardUnit: PropTypes.bool,
    selectableRegistrationIds: PropTypes.array,
    setRegistrationSelectedTo: PropTypes.func.isRequired,
    areAllRegistrationsSelected: PropTypes.bool,
    bulkSelectRegistrations: PropTypes.func.isRequired,
    setCommonLimit: PropTypes.func,
    configuration: PropTypes.object,
    activeOrganization: PropTypes.object
  }

  static defaultProps = {
    withAwardUnit: false
  }

  state = {
    selectedTaskId: null,
    awardId: null,
    participantPersonDetail: null,
    awardDetail: null,
    awardApproveId: null,
    tasksLoading: false
  }

  handleEditModal = selectedTaskId => {
    this.setState(
      {
        tasksLoading: true,
        selectedTaskId
      },
      () => {
        this.handleFetchRegistrationTasks(selectedTaskId)
      }
    )
  }

  handleFetchRegistrationTasks = selectedTaskId => {
    return this.props
      .onRefreshTaskParticipantRegistration(selectedTaskId, { enableLoading: false })
      .then(({ body = [] }) => {
        const task = body.filter(item => item.id === selectedTaskId)[0] || {}

        this.setState(
          {
            awardDetail: get(task, 'award'),
            participantPersonDetail: get(task, 'participantPerson'),
            awardId: get(task, 'award.id')
          },
          () => {
            this.props.modal('modal-edit')
            this.setState({
              tasksLoading: false
            })
          }
        )
      })
      .catch(() => {
        this.setState({
          tasksLoading: false
        })
      })
  }

  handleApproveModal = awardApproveId => {
    this.setState(
      {
        awardApproveId
      },
      () => {
        this.props.modal('modal-approve')
      }
    )
  }

  render() {
    const {
      tasks: { loading, list, limit, offset, pages, sort, selectedIds },
      selectableRegistrationIds: selectableIds,
      approveParticipantRegistration,
      deleteParticipantRegistration,
      disablePersistedFilter,
      withAwardUnit,
      areAllRegistrationsSelected,
      bulkSelectRegistrations,
      setRegistrationSelectedTo,
      setRegistrationTasksParams,
      setCommonLimit,
      configuration,
      activeOrganization
    } = this.props

    const { selectedTaskId, tasksLoading } = this.state

    const safeSelectedIds = selectedIds || []

    const isLabelsEnabled = get(configuration, `valuesByOrganizationId[${activeOrganization.id}][${CONFIGURATION_KEYS.enableLabels.id}].booleanValue`)


    const ExportComponent = (
      <Export
        exportName="ParticipantsRegistrations"
        toExport={this.props.exportParticipantRegistrations}
        exportSchemeValue="registrations-participants"
        count={this.props.tasks && this.props.tasks.count}
      />
    )

    return (
      <div>
        <FilterTasksRegistration
          disablePersistedFilter={disablePersistedFilter}
        />

        <BulkChangeAwardRegistrations
          selectedIds={safeSelectedIds}
          registrationList={list}
        />

        <Table
          loading={loading && !tasksLoading}
          length={list.length}
          offset={offset}
          limit={limit}
          onSetLimit={setCommonLimit}
          pages={pages}
          sort={sort}
          ths={tasksLayout.registrationTableHeaders({ withAwardUnit, isLabelsEnabled })}
          areAllSelected={areAllRegistrationsSelected ? true : undefined}
          bulkSelect={() => bulkSelectRegistrations(safeSelectedIds, selectableIds)}
          setParams={setRegistrationTasksParams}
          dataTestId="awardRegistrationTable"
          exportComponent={ExportComponent}
        >
          <Data>
            {list.map(({
              id,
              participantPerson,
              award,
              isBlocked,
              organization,
              duplicityInfo
            }) => (
              <tr key={id}>
                <RowSelectorTd
                  enabled={selectableIds && selectableIds.includes(get(award, 'id')) ? true : undefined}
                  selected={selectedIds && selectedIds.includes(get(award, 'id')) ? true : undefined}
                  setSelected={val => setRegistrationSelectedTo(get(award, 'id'), val)}
                />
                <td>
                  <Link to={`${config.publicPath}/participants/${get(participantPerson, 'id')}`}>
                    {get(participantPerson, 'globalId')}
                  </Link>
                </td>
                <td>{get(participantPerson, 'firstName')}</td>
                <td>
                  {get(participantPerson, 'lastName')}
                </td>
                <td>{get(award, 'createAwardActionDate') && <FormattedDate value={get(award, 'createAwardActionDate')} />}</td>
                <td>
                  <BadgesLevels levels={[award]} participantId={get(participantPerson, 'id')} single />
                </td>
                {withAwardUnit &&
                  <td>
                    {get(organization, 'name')}
                  </td>}
                <td>
                  <Status
                    state={get(participantPerson, 'isEmailConfirmed')}
                    check
                  />
                </td>
                {isLabelsEnabled && <td>
                  {get(participantPerson, 'labels') && getLabels(get(participantPerson, 'labels'), null)}
                </td> }
                <Table.Td>
                  {get(award, 'consentDeliveryType.translationText')}
                  {get(award, 'consentDeliveryType.value') !==
                    CONSENT_DELIVERY_TYPES.notRequired.id
                    ? <Status
                        state={get(award, 'isConsentDeliveryConfirmed')}
                        check
                        inline
                        toRight
                      />
                    : <Status state check inline toRight />}
                </Table.Td>
                <Table.Td>
                  {get(award, 'paymentState.translationText') || '---'}
                  <Status
                    state={get(award, 'isPaymentConfirmed')}
                    check
                    inline
                    toRight
                  />
                </Table.Td>
                <Table.Td>
                  <Button
                    onClick={() => this.handleEditModal(id)}
                    tiny
                    secondary
                    isLoading={tasksLoading && selectedTaskId === id}
                    dataTestId="confirmRegistrationButton"
                    intlKey="button.confirm"
                  >
                    Confirm
                  </Button>
                </Table.Td>
                <td>
                  <div style={{ float: 'left' }}>
                  <ButtonGroup>
                    {get(award, 'awardLeader') &&
                      <Button
                        onClick={() =>
                          this.handleApproveModal(get(award, 'id'))}
                        disabled={isBlocked}
                        intlKey="button.approve"
                        dataTestId="approveRegistrationButton"
                        tiny
                      >
                        Approve
                      </Button>}
                    {!get(award, 'awardLeader') &&
                      isBlocked &&
                      <Link
                        className="btn"
                        to={`${config.publicPath}/participants/${get(participantPerson, 'id')}`}
                      >
                        <FormattedMessage
                          id="button.assign_leader"
                          defaultMessage="Assign leader"
                        />
                      </Link>}
                  </ButtonGroup>
                  </div>
                  {duplicityInfo && <DuplicityInfo data={duplicityInfo} />}
                </td>
              </tr>
            ))}
          </Data>
        </Table>
        <Modal id="modal-edit" customActions>
          <TaskParticipantEdit
            key={this.state.awardId}
            award={this.state.awardDetail}
            awardId={this.state.awardId}
            person={this.state.participantPersonDetail}
            onRegistrationDelete={deleteParticipantRegistration}
            onEditSubmit={this.props.onRegistrationAwardEdit}
          />
        </Modal>
        <Modal id="modal-approve" customActions>
          <TaskApprove
            approve={approveParticipantRegistration}
            id={this.state.awardApproveId}
            modal={this.props.modal}
            title="Approve award registration"
            intlKey="tasks.approve_award_registration"
          />
        </Modal>
      </div>
    )
  }
}

export default enhance(TasksRegistrationParticipants)
